<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <!-- <notifications></notifications> -->
    <!-- <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    > -->
    <side-bar
      v-if="$sidebar.showSidebar"
      :style="backgroundColorStyle"
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    >
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/assets" :changeIcon="() => checkClick(0)">
        <md-icon class="md-size-3x" :md-src="svgData[0].icon"></md-icon>
        <p>Assets</p>
      </sidebar-link>

      <sidebar-link
        v-if="userType !== 'basic'"
        to="/dashboard"
        :changeIcon="() => checkClick(1)"
      >
        <md-icon class="md-size-3x" :md-src="svgData[1].icon"></md-icon>
        <p>Dashboard</p>
      </sidebar-link>

      <sidebar-link to="/viewer" :changeIcon="() => checkClick(2)">
        <md-icon class="md-size-3x" :md-src="svgData[2].icon"></md-icon>
        <p>Viewer</p>
      </sidebar-link>
      <sidebar-link to="/editor" :changeIcon="() => checkClick(3)">
        <md-icon class="md-size-3x" :md-src="svgData[3].icon"></md-icon>
        <p>Editor</p>
      </sidebar-link>
      <div
        style="display: flex; position: absolute; left: 20px; bottom: 3%"
        class="ma-0 pa-0"
      >
        <div class="ma-0 pa-0">
          <v-menu
            rounded="lg"
            :close-on-content-click="false"
            transition="scale-transition"
            top
            offset-y
            max-width="170"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" elevation="0" style="box-shadow: none"
                ><v-icon>mdi-tune</v-icon></v-btn
              >
            </template>
            <v-card
              class="ma-0 pa-0"
              rounded="lg"
              width="175"
              height="300"
              :style="{
                background: $vuetify.theme.themes[theme].background,
              }"
            >
              <div class="pl-7 pt-4 ma-0">
                <p class="display-22"><strong>Customize UI</strong></p>
                <p class="caption-11">Highlight Color</p>
                <v-avatar
                  class="mr-3 mt-n2"
                  style="cursor: pointer"
                  v-for="(item, index) in itemscolor"
                  :key="index"
                  :color="item.color"
                  @click="colorff(item)"
                  size="19"
                ></v-avatar>
                <p class="caption-11 mt-2">Sidebar Color</p>
                <v-avatar
                  class="mr-3 mt-n2"
                  v-for="(item, index) in itemsbackcolor"
                  :key="index"
                  :color="item.color"
                  @click="colorf(item)"
                  style="cursor: pointer"
                  size="19"
                ></v-avatar>
                <p class="caption-11 mt-2">Icon Size</p>
                <v-row class="ma-0 pa-0 ml-n3 mt-n3 mr-3">
                  <v-btn icon class="pt-1"
                    ><v-icon size="17">mdi-square</v-icon></v-btn
                  >
                  <v-slider
                    class="ma-0 pa-0 mt-1"
                    v-model="iconRowSize"
                    size="30"
                    max="150"
                    min="70"
                    track-color="grey"
                    track-fill-color="grey"
                  ></v-slider>
                  <v-btn icon
                    ><v-icon size="30"
                      >mdi-checkbox-blank-outline</v-icon
                    ></v-btn
                  >
                </v-row>
                <p
                  class="display-22 mt-n3"
                  style="color: #6699cc; font-weight: 900; letter-spacing: 2px"
                >
                  <strong
                    v-if="augmentableTheme"
                    @click="changeTheme()"
                    style="cursor: pointer"
                    >BRIGHTMODE</strong
                  >
                  <strong
                    v-if="!augmentableTheme"
                    @click="changeTheme()"
                    style="cursor: pointer"
                    >DARKMODE</strong
                  >
                </p>
              </div>
            </v-card>
          </v-menu>
        </div>
        <div class="ma-0 pa-0 mt-n1">
          <v-btn @click="changeTheme()" icon
            ><md-icon
              v-if="augmentableTheme"
              class="md-size-1x"
              md-src="/static/assets/svg/white/sun.svg"
            ></md-icon
            ><md-icon
              v-if="!augmentableTheme"
              class="md-size-1x"
              md-src="/static/assets/svg/white/moon.svg"
            ></md-icon>
          </v-btn>
        </div>
        <div class="ma-0 pa-0 pt-1">
          <p style="color: #1976d2; cursor: pointer" @click="addfile">
            Add new asset
          </p>
        </div>
      </div>
    </side-bar>

    <div
      class="main-panel"
      v-bind:style="$sidebar.showSidebar ? '' : 'width: 100% !important;'"
    >
      <top-navbar
        style="position: fixed; top: 0; right: 0; width: auto"
      ></top-navbar>

      <!--
      <fixed-plugin
        :color.sync="sidebarBackground"
        :image.sync="sidebarBackgroundImage"
      ></fixed-plugin>
      -->

      <dashboard-content></dashboard-content>
      <!--<dashboard-core-settings /> -->

      <!--<content-footer v-if="!$route.meta.hideFooter"></content-footer>-->
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
//import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu.vue";
//import FixedPlugin from "./Extra/FixedPlugin.vue";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import store from "../../store";
import { mapState } from "vuex";

//import "../../assets/scss/material-dashboard.scss";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    //ContentFooter,
    MobileMenu,
    //FixedPlugin,

    //DashboardCoreSettings: () =>
    //import("../../views/dashboard/components/core/Settings"),
  },
  data() {
    return {
      sidebarBackground: "green",
      sidebarBackgroundImage: "blue",
      bgColor: "grey",

      itemscolor: [
        { color: "yellow" },
        { color: "blue" },
        { color: "red" },
        { color: "pink" },
      ],
      itemsbackcolor: [
        { color: "#d0d0d0" },
        { color: "#000000" },
        { color: "#404040" },
      ],
      userInfo: {
        id: "",
        username: "",
        email: "",
        first_name: "",
        last_name: "",
      },
      userType: "basic",
      svgData: [
        {
          name: "assets",
          icon: "/static/assets/svg/white/assetsThick.svg",
          checked: true,
        },
        {
          name: "dashboard",
          icon: "/static/assets/svg/white/dashboardThin.svg",
          checked: false,
        },
        {
          name: "viewer",
          icon: "/static/assets/svg/white/viewerThin.svg",
          checked: false,
        },
        {
          name: "editor",
          icon: "/static/assets/svg/white/editorThin.svg",
          checked: false,
        },
      ],
    };
  },

  computed: {
    ...mapState(["augmentableTheme"]),
    backgroundColorStyle() {
      return {
        "background-color": this.bgColor,
      };
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    iconRowSize: {
      get() {
        return store.state.iconrowSize;
      },
      set(val) {
        this.$store.commit("setIconRowSize", val);
      },
    },
  },
  mounted() {
    if (this.augmentableTheme === true) {
      this.darkTheme = true;
      this.colorTheme = "#d3d3d3";
    } else {
      this.lightTheme = true;
      this.colorTheme = "black";
    }

    this.$store.commit("setEditorSidebar", true);

    this.userType = store.state.userType;
    // axios
    //   .get("/dj-rest-auth/user/", {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization:
    //         "Token " + this.getAuthCookie("augmentableUserToken") + "",
    //     },
    //   })
    //   .then((response) => {
    //     this.userInfo.id = response.data.pk;
    //     this.userInfo.username = response.data.username;
    //     this.userInfo.email = response.data.email;
    //     this.userInfo.first_name = response.data.first_name;
    //     this.userInfo.last_name = response.data.last_name;

    //     axios
    //       .get(
    //         "/api/users1/userInfooID/" +
    //           this.userInfo.id +
    //           "/"
    //       )
    //       .then((response) => {
    //         // console.log(response);
    //         // console.log(response.data);
    //         this.userType = response.data.user_type;
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //   })
    //   .catch((response) => {
    //     //console.log("user information22");
    //     console.log(response);
    //     //console.log(response.data);
    //   });
  },
  methods: {
    changeTheme() {
      if (this.augmentableTheme === true) {
        this.$store.commit("setAugmentableTheme", false);
        this.$vuetify.theme.dark = false;
      } else if (this.augmentableTheme === false) {
        this.$store.commit("setAugmentableTheme", true);
        this.$vuetify.theme.dark = true;
      }
    },
    colorf(x) {
      this.bgColor = x.color;
    },
    addfile() {
      this.$router.push({ path: "/addFile" });
    },
    checkClick(x) {
      if (x === 0) {
        this.svgData[0].icon = "/static/assets/svg/white/assetsThick.svg";
        this.svgData[1].icon = "/static/assets/svg/white/dashboardThin.svg";
        this.svgData[2].icon = "/static/assets/svg/white/viewerThin.svg";
        this.svgData[3].icon = "/static/assets/svg/white/editorThin.svg";
      } else if (x === 1) {
        this.svgData[0].icon = "/static/assets/svg/white/assetsThin.svg";
        this.svgData[1].icon = "/static/assets/svg/white/dashboardThick.svg";
        this.svgData[2].icon = "/static/assets/svg/white/viewerThin.svg";
        this.svgData[3].icon = "/static/assets/svg/white/editorThin.svg";
      } else if (x === 2) {
        this.svgData[0].icon = "/static/assets/svg/white/assetsThin.svg";
        this.svgData[1].icon = "/static/assets/svg/white/dashboardThin.svg";
        this.svgData[2].icon = "/static/assets/svg/white/viewerThick.svg";
        this.svgData[3].icon = "/static/assets/svg/white/editorThin.svg";
      } else if (x === 3) {
        this.svgData[0].icon = "/static/assets/svg/white/assetsThin.svg";
        this.svgData[1].icon = "/static/assets/svg/white/dashboardThin.svg";
        this.svgData[2].icon = "/static/assets/svg/white/viewerThick.svg";
        this.svgData[3].icon = "/static/assets/svg/white/editorThin.svg";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/material-dashboard.scss";
.hoverIcon {
  stroke: white;
}
.hoverIcon:hover {
  stroke-linejoin: miter;
  stroke-width: 1em;
  stroke: white;
}
</style>
